<template>
  <div class="login-page">
    <!-- 粒子背景 -->
    <canvas id="particle-canvas"></canvas>

    <div class="login-container">
      <!-- 左侧图片部分 -->
      <div class="left-banner">
        <img :src="agentInfo.agent_login_image" alt="代理端" class="banner-image" />
      </div>

      <!-- 右侧登录表单部分 -->
      <div class="right-form">
        <div class="form-content">
          <!-- 显示代理端名称 -->
          <h2 class="form-title">
            <span v-if="agentInfo.agent_name">{{ agentInfo.agent_name }}</span>
          </h2>
          <p class="form-subtitle">让您的业务更高效</p>
          <el-form :model="form" ref="loginForm" class="login-form" @submit.prevent="handleLogin">
            <el-form-item>
              <el-input v-model="form.username" placeholder="请输入账号" prefix-icon="User" size="large" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.password" placeholder="请输入密码" prefix-icon="lock" show-password size="large" />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="form.remember" size="large">记住账号</el-checkbox>
            </el-form-item>
            <el-button type="primary" block class="login-button" @click="handleLogin" size="large">登录</el-button>
          </el-form>
          <p class="form-footer">
            忘记密码？<a href="javascript:void(0);" @click="handleForgotPassword">点击这里</a>
          </p>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="global-footer" v-if="copyrightList.length > 0">
      <div class="copyright-wrapper">
        <div v-for="(item, index) in copyrightList" :key="index" class="copyright-item">
          <a :href="item.value" target="_blank" rel="noopener noreferrer">{{ item.key }}</a>
          <span v-if="index < copyrightList.length - 1" class="copyright-separator">|</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
import config from '@/config.js'; // 引入配置文件

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: false,
      },
      agentInfo: {
        agent_name: '',
        agent_favicon: '',
        agent_logo: '',
        agent_login_image: '',
      },
      copyrightList: [], // 版权信息列表
    };
  },
  methods: {
    async handleLogin() {
      if (!this.form.username || this.form.username.length < 6) {
        this.$message.error("请输入至少6位的账号");
        return;
      }
      if (!this.form.password || this.form.password.length < 6) {
        this.$message.error("请输入至少6位的密码");
        return;
      }

      try {
        const response = await axios.post(
          `${config.BASE_URL}/agent/api/login.php`,
          {
            username: this.form.username,
            password: this.form.password,
          }
        );

        if (response.data.success) {
          this.$message.success("登录成功");

          // 获取登录返回的完整用户数据
          const userData = response.data.data; // { id: "54", username: "agent001", out_date: "2026-04-30" }

          // 保存完整的用户信息（包含 id）
          auth.saveUser({
            id: userData.id,
            username: userData.username,
            out_date: userData.out_date,
            password: this.form.password // 保存密码用于自动填充
          }, this.form.remember);

          this.$router.push({ path: "/home/merchant-management" });
        } else {
          this.$message.error(response.data.error || "登录失败");
        }
      } catch (error) {
        console.error("登录请求错误:", error);
        this.$message.error("登录失败，请检查网络或稍后重试");
      }
    },

    handleForgotPassword() {
      this.$message.info('请联系管理员重置密码，谢谢合作！');
    },

    async getAgentInfo() {
      try {
        // 获取当前运行域名
        const currentDomain = window.location.hostname;

        // 传递域名参数
        const response = await axios.get(`${config.BASE_URL}/agent/api/get_agent_info.php`, {
          params: {
            domain: currentDomain
          }
        });

        if (response.data.success && response.data.data) {
          this.agentInfo = response.data.data;

          if (response.data.data.copyright && Array.isArray(response.data.data.copyright)) {
            this.copyrightList = response.data.data.copyright;
          }
        }
      } catch (error) {
        console.error("获取代理信息失败:", error);
      }
    },


    initParticles() {
      const canvas = document.getElementById('particle-canvas');
      const ctx = canvas.getContext('2d');

      const particles = [];
      const particleCount = 100;

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      window.addEventListener('resize', () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      });

      class Particle {
        constructor() {
          this.x = Math.random() * canvas.width;
          this.y = Math.random() * canvas.height;
          this.radius = Math.random() * 3 + 1;
          this.color = 'rgba(255, 255, 255, 0.8)';
          this.vx = Math.random() * 2 - 1;
          this.vy = Math.random() * 2 - 1;
        }

        draw() {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
          ctx.fillStyle = this.color;
          ctx.fill();
        }

        update() {
          this.x += this.vx;
          this.y += this.vy;

          if (this.x < 0 || this.x > canvas.width) this.vx *= -1;
          if (this.y < 0 || this.y > canvas.height) this.vy *= -1;
        }
      }

      function init() {
        for (let i = 0; i < particleCount; i++) {
          particles.push(new Particle());
        }
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach((particle) => {
          particle.update();
          particle.draw();
        });
        requestAnimationFrame(animate);
      }

      init();
      animate();
    },
  },
  mounted() {
    this.getAgentInfo(); // 获取代理信息
    this.initParticles();
    auth.autoRedirect(this.$router); // 自动跳转到主页
  },
  created() {
    const savedUser = auth.getStoredUser();
    if (savedUser) {
      this.form.username = savedUser.username;
      this.form.remember = true; // 记住账号
    }
  },
};
</script>

<style scoped>
/* 页面背景保持不变，复制自原有 Login.vue */
.login-page {
  height: 100vh;
  background: linear-gradient(120deg, #7a88ff, #162447, #1e1e2f, #7a88ff);
  background-size: 400% 400%;
  animation: gradientMove 6s ease infinite;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: relative;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* 页面背景 */
.login-page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 粒子背景 */
#particle-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  /* 禁止交互 */
}

/* 登录容器 */
.login-container {
  position: relative;
  z-index: 2;
  /* 确保在粒子背景之上 */
  display: flex;
  width: 80%;
  max-width: 900px;
  height: 450px;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
}

/* 左侧图片部分 */
.left-banner {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右侧表单部分 */
.right-form {
  flex: 1;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-content {
  width: 100%;
  max-width: 350px;
}

.form-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.form-subtitle {
  font-size: 14px;
  color: #888;
  text-align: center;
  margin-bottom: 20px;
}

.login-form .el-input {
  margin-bottom: 20px;
}

.login-button {
  margin-top: 5px;
  border-radius: 8px;
  width: 100%;
}

.form-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
}

.form-footer a {
  color: #409eff;
  text-decoration: none;
}

.form-footer a:hover {
  text-decoration: underline;
}

/* 底部版权信息样式 */
.global-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  z-index: 3;
  text-align: center;
}

.copyright-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.copyright-item {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.copyright-item a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s;
}

.copyright-item a:hover {
  color: #fff;
  text-decoration: underline;
}

.copyright-separator {
  margin: 0 8px;
  color: rgba(255, 255, 255, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    height: auto;
    border-radius: 12px;
  }

  .left-banner {
    height: 200px;
  }

  .right-form {
    padding: 20px;
  }

  .global-footer {
    padding: 12px 16px;
  }

  .copyright-item {
    font-size: 10px;
  }
}
</style>